/***
 * Uppercase the first character in the text
 * @param {string} text - text to apply ucfirst to
 * @returns {string} - text with first character capitalised
 */
export default function ucfirst(text) {
    if (!text) return "";
    return text.slice(0,1).toUpperCase() + text.slice(1);
}